// frontend/src/components/icons/Icons.js
// Stroke icon set replacing the emoji. All inherit currentColor + accept className.

const S = ({ children, className = 'w-4 h-4', sw = 1.6 }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round">{children}</svg>
);

export const IconHome = (p) => (
  <S {...p}><path d="M3 10.5 12 4l9 6.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z" /></S>
);

export const IconCar = (p) => (
  <S {...p}>
    <path d="M3.5 16.5v-4.8a1 1 0 0 1 .7-1L6.4 10l1.5-3.1a1 1 0 0 1 .9-.6h6.4a1 1 0 0 1 .9.6L17.6 10l2.2.7a1 1 0 0 1 .7 1v4.8" />
    <path d="M6.2 10.2h11.6M2.6 16.5h18.8" />
    <circle cx="7.8" cy="17.6" r="1.5" /><circle cx="16.2" cy="17.6" r="1.5" />
  </S>
);

export const IconCalendar = (p) => (
  <S {...p}><path d="M4 7h16v13H4zM4 11h16M8 4v3M16 4v3" /></S>
);

export const IconWrench = (p) => (
  <S {...p}>
    <path d="m15 4 2.5-1L20 5.5 19 8l-7.5 7.5" />
    <path d="M11.5 15.5 5 22l-3-3 6.5-6.5" />
    <path d="M8.5 12.5 4 8V4h4l4.5 4.5" />
  </S>
);

export const IconDoc = (p) => (
  <S {...p}><path d="M14 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7z" /><path d="M14 3v4h4M9 13h6M9 17h4" /></S>
);

export const IconClipboard = (p) => (
  <S {...p}><path d="M9 4h6v3H9z" /><path d="M7 5H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-1M9 12h6M9 16h4" /></S>
);

export const IconTow = (p) => (
  <S {...p}><path d="M3 7h9v10H3zM12 10h4l3 3v4h-7" /><path d="M6.5 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16.5 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" /></S>
);

export const IconCard = (p) => (
  <S {...p}><path d="M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM3 11h18" /></S>
);

export const IconBox = (p) => (
  <S {...p}><path d="M12 3 21 7.5v9L12 21 3 16.5v-9zM3 7.5 12 12l9-4.5M12 12v9" /></S>
);

export const IconSpark = (p) => (
  <S {...p}>
    <path d="M12 3.5l1.7 4.4 4.4 1.7-4.4 1.7L12 15.7l-1.7-4.4L5.9 9.6l4.4-1.7z" />
    <path d="M18 16.5l.8 1.9 1.9.8-1.9.8-.8 1.9-.8-1.9-1.9-.8 1.9-.8z" />
  </S>
);

export const IconWarn = (p) => (
  <S sw={1.9} {...p}><path d="M12 4.5 21 19H3z" /><path d="M12 10v4M12 16.6h.01" /></S>
);

export const IconClock = (p) => (
  <S {...p}><circle cx="12" cy="12" r="8" /><path d="M12 8v4l3 2" /></S>
);

export const IconChevron = (p) => (
  <S sw={1.8} {...p}><path d="m9 5 7 7-7 7" /></S>
);

export const IconPencil = (p) => (
  <S sw={1.7} {...p}><path d="M4 20h4l10-10-4-4L4 16z" /><path d="m14 6 4 4" /></S>
);

export const IconPlus = (p) => (
  <S sw={2.1} {...p}><path d="M12 5v14M5 12h14" /></S>
);

export const IconDownload = (p) => (
  <S sw={1.7} {...p}><path d="M12 4v10M8 11l4 4 4-4M5 19h14" /></S>
);

export const IconSearch = (p) => (
  <S sw={1.8} {...p}><circle cx="11" cy="11" r="6.5" /><path d="m16 16 4 4" /></S>
);

export const IconBell = (p) => (
  <S {...p}><path d="M18 15V10a6 6 0 1 0-12 0v5l-1.5 2.5h15z" /><path d="M10 20a2 2 0 0 0 4 0" /></S>
);

export const IconHelp = (p) => (
  <S {...p}><circle cx="12" cy="12" r="9" /><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6v.3M12 17h.01" /></S>
);

export const IconLogout = (p) => (
  <S {...p}><path d="M15 17l4-5-4-5M19 12H9M11 4H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5" /></S>
);

export const IconCheck = (p) => (
  <S sw={3} {...p}><path d="m5 13 4 4L19 7" /></S>
);
